import { call, put, select, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { push } from 'connected-react-router';
import {
  GO_TO_FORGOT_PASSWORD,
  LOAD_PASSWORD_MODE,
  passwordChangeActions,
  PROCESS_PASSWORD_RESET,
  REQUEST_PASSWORD_RESET
} from '../reducer/password-change-reducer';
import {
  loadPasswordMode,
  processServerPasswordReset,
  requestServerPasswordReset
} from '../services/password-change-helpers';
import { authActions, authSelectors } from '@rosetta/react-auth';
import { appActions, TRANSACTION_STATE } from '../../app/reducer/app-reducer';
import { emitEvent, RESET_PASSWORD } from '../../../helpers/eventingHelper';

function* requestPasswordReset(action) {
  try {
    yield call(emitEvent, RESET_PASSWORD, {
      Email: action.payload.userEmail,
      Application: 'Launchpad',
      'Application Version': '0.1.0'
    });
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.PENDING));
    const authToken = yield select(authSelectors.authToken);
    yield call(requestServerPasswordReset, action.payload.userEmail, authToken);
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.SUCCESS));
  } catch (error) {
    return yield put(appActions.setLastTransactionState(TRANSACTION_STATE.FAIL, JSON.parse(error.message).error));
  }
}

function* loadPasswordModeSaga(action) {
  yield put(passwordChangeActions.storePasswordMode(''));
  const pwMode = yield call(loadPasswordMode, {
    userId: action.payload.userId,
    resetPasswordId: action.payload.resetPasswordId
  });
  const modeString = pwMode.strict ? 'strict' : 'simple';
  yield put(passwordChangeActions.storePasswordMode(modeString));
}

function* processPasswordReset(action) {
  try {
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.PENDING));
    const authToken = yield select(authSelectors.authToken);
    yield call(processServerPasswordReset, action.payload.resetRequestUuid, action.payload.newPassword, authToken);
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.SUCCESS));
    // this is to let the success screen appear for a bit
    yield delay(2500);
    yield put(push('/login'));
  } catch (error) {
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.FAIL, JSON.parse(error.message).error));
    const errMsg = JSON.parse(error.message).error;
    if (errMsg === 'REQUEST_INVALID') {
      yield put(push('/forgot-password'));
    }
  }
}

function* goToForgotPassword(action) {
  yield put(authActions.clearAuthError());
  yield put(passwordChangeActions.storeUserEmail(action.payload.userEmail));
  yield put(appActions.setLastTransactionState(TRANSACTION_STATE.NO_TRANSACTION));
  yield put(push('/forgot-password'));
}

export function* passwordChangeSagas() {
  yield takeLatest(LOAD_PASSWORD_MODE, loadPasswordModeSaga);
  yield takeLatest(REQUEST_PASSWORD_RESET, requestPasswordReset);
  yield takeLatest(PROCESS_PASSWORD_RESET, processPasswordReset);
  yield takeLatest(GO_TO_FORGOT_PASSWORD, goToForgotPassword);
}



// WEBPACK FOOTER //
// ./src/modules/login/sagas/password-change-sagas.js